<template>
	<div class="flex flex-col items-end gap-6 px-6 pb-6 font-[Inter]">
		<div class="flex w-full flex-col gap-2">
			<h2 class="text-xl leading-7 font-semibold text-[#111827]">
				Get Resume From LinkedIn
			</h2>
			<ol class="list-decimal space-y-1 pl-6 text-base leading-6 text-[#6B7280]">
				<li>
					Go to <span class="font-medium text-[#111827]">linkedin.com</span>
				</li>
				<li>
					Click the
					<UserCircleIcon
						class="inline size-4 align-[-2px] text-[#111827]"
						aria-hidden="true"
					/><span class="font-medium text-[#111827]">Me</span> icon at the LinkedIn header
				</li>
				<li>
					Click <span class="font-medium text-[#111827]">View profile</span>
				</li>
				<li>
					Click the <span class="font-medium text-[#111827]">More</span> or
					<span class="font-medium text-[#111827]">Resources</span> button
				</li>
				<li>
					Select
					<ArrowDownTrayIcon
						class="inline size-4 align-[-2px] text-[#111827]"
						aria-hidden="true"
					/><span class="font-medium text-[#111827]">Save to PDF</span> from the dropdown
				</li>
				<li>Upload the downloaded file</li>
			</ol>
		</div>

		<div class="flex gap-2">
			<Button
				size="lg"
				variant="ghost"
				class="rounded-md bg-[#F3F4F6] px-4 text-[#111827] hover:bg-[#E5E7EB]"
				@click="store.backToUpload"
			>
				Back
			</Button>
			<Button
				size="lg"
				class="rounded-md px-3"
				@click="openLinkedIn"
			>
				<ArrowTopRightOnSquareIcon
					class="size-5"
					aria-hidden="true"
				/>
				Open LinkedIn
			</Button>
		</div>
	</div>
</template>

<script setup>
import { ArrowDownTrayIcon, UserCircleIcon } from '@heroicons/vue/24/outline';
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid';

import { Button } from '../../../components/ui/button';
import { useAutoApplyPromoStore } from '../../../store/auto-apply-promo.store';
import { openLink } from '../../../utils/helpers';

const LINKEDIN_PROFILE_URL = 'https://www.linkedin.com/in/me/';

const store = useAutoApplyPromoStore();

// Per the design, this popup closes once LinkedIn opens, returning to the upload step so the
// downloaded PDF can be dropped straight in.
const openLinkedIn = () => {
	openLink(LINKEDIN_PROFILE_URL, true);
	store.backToUpload();
};
</script>
